import { makeAutoObservable } from 'mobx';
import { getUserVoteCount } from './fn/getUserVoteCount';
import { CandidateScoreData, StandAdminUserVote, UserVoteCount } from '~/definitions/report';
import { DEFAULT_USER_VOTE_COUNT } from '~/consts/report';
import sendReportEmail from './fn/sendReportEmail';
import { onEmailChange } from './fn/onEmailChange';
import { getCandidateScoreListByRegion } from './fn/getCandidateScoreListByRegion';
import { getStandAdminUserVoteListByRegion } from './fn/getStandAdminUserVoteListByRegion';
import { getIsLoading } from './fn/getIsLoading';
import onClickElectionMenu from './fn/handleFetchReportData';
import handleFetchReportData from './fn/handleFetchReportData';

export default class ReportStore {
    userCount: UserVoteCount = DEFAULT_USER_VOTE_COUNT;
    totalUserCount: number = 0;
    votesList: CandidateScoreData[] = [];
    isGettingCandidateScoreList: boolean = false;

    email: string = '';

    totalUserVoteList: number = 0;
    standAdminUserVoteList: StandAdminUserVote[] = [];

    isLoadingStandAdminUserVoteList: boolean = false;
    isShowedUserVoteList: boolean = false;
    isGettingUserVoteCount: boolean = false;
    isSendingReportFile: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.userCount = DEFAULT_USER_VOTE_COUNT;
        this.totalUserCount = 0;
        this.standAdminUserVoteList = [];
        this.isLoadingStandAdminUserVoteList = false;
        this.isShowedUserVoteList = false;
        this.votesList = [];
        this.email = '';

        this.isGettingCandidateScoreList = false;
        this.isGettingUserVoteCount = false;
        this.isShowedUserVoteList = false;
        this.isSendingReportFile = false;
    }

    setUserVoteCount = (userVoteCount: UserVoteCount) => {
        this.userCount = userVoteCount;
    };

    setTotalUserCount = (totalUserCount: number) => {
        this.totalUserCount = totalUserCount;
    };

    setStandAdminUserVoteList = (standAdminUserVoteList: StandAdminUserVote[]) => {
        this.standAdminUserVoteList = standAdminUserVoteList;
    };

    setIsLoadingStandAdminUserVoteList = (isLoading: boolean) => {
        this.isLoadingStandAdminUserVoteList = isLoading;
    };

    setIsShowedUserVoteList = (isShowed: boolean) => {
        this.isShowedUserVoteList = isShowed;
    };

    setVotesList = (votesList: CandidateScoreData[]) => {
        this.votesList = votesList;
    };

    setIsGettingCandidateScoreList = (isLoading: boolean) => {
        this.isGettingCandidateScoreList = isLoading;
    };

    setIsGettingUserVoteCount = (isGetting: boolean) => {
        this.isGettingUserVoteCount = isGetting;
    };

    setEmail = (value: string) => {
        this.email = value;
    };

    setIsSendingReportFile = (value: boolean) => {
        this.isSendingReportFile = value;
    };

    getUserVoteCount = getUserVoteCount;
    getStandAdminUserVoteListByRegion = getStandAdminUserVoteListByRegion;
    getCandidateScoreListByRegion = getCandidateScoreListByRegion;
    onEmailChange = onEmailChange;
    getIsLoading = getIsLoading;
    onClickElectionMenu = onClickElectionMenu;
    handleFetchReportData = handleFetchReportData;
    sendReportEmail = sendReportEmail;
}
